import { getNumberFormat } from './getNumberFormat';

const smallFormatter = getNumberFormat('en', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 2,
});

const largeFormatter = getNumberFormat('en', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1,
});

/**
 * Formats a number using Intl.NumberFormat. For numbers less than 1000 and greater than -1000,
 * up to two decimal places are used. For other numbers, a roman numeral (such as K for "thousand")
 * is appended and only one decimal place is used.
 *
 * Examples:
 *      formatNumberCompact(.01) =>  0.01
 *      formatNumberCompact(999.01) =>  999.01
 *      formatNumberCompact(1110.01) =>  1.1K
 *      formatNumberCompact(203013.01) =>  203K
 *      formatNumberCompact(1324683212.12) =>  1.3B
 * @param param
 */
export const formatNumberCompact = (value: Maybe<number>): string => {
    if (value === null) {
        return '0';
    }

    if (value < 1000 && value > -1000) {
        return smallFormatter.format(value);
    }

    return largeFormatter.format(value);
};
